import React, { Component } from 'react'
import QRCode from 'qrcode.react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { FileCopy } from '@material-ui/icons';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck, faAppleAlt, faMobileAndroid, faDesktopAlt, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { faApple, faAndroid, faChrome, faFirefox, faWindows, faSafari } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress, IconButton } from "@material-ui/core";
import TextDivider from '../../../components/Divider/TextDivider';
import CustomInput from '../../../components/CustomInput/CustomInput';
import CheckAnimated from '../../../components/Icon/CheckAnimated';
import Api from '../../../api/Api.js';
import AuthEndpoints from '../../../api/AuthEndpoints';
import Loading from '../../../components/Loading/Loading';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class MFADialog extends Component {

    state = {
        tab: 0,
        loading: false,
        mfa_url: '',
        otp: '',
        otpInvalid: false,
        otpTestSuccess: false
    }

    copyUrl() {
        this.copyTextarea.select();
        document.execCommand('copy');
    }

    generateMFAKey() {
        this.setState({ loading: true }, () => {
            Api.get(AuthEndpoints.addMFA)
                .then(({ data }) => {
                    console.log(data.mfa_url);
                    this.setState({ loading: false, mfa_url: decodeURI(data.mfa_url) })
                })
                .catch((e) => {
                    console.error(e);
                })
        })
    }

    testMFA() {
        Api.get(AuthEndpoints.testMFA, { otp: this.state.otp })
            .then(({ data }) => this.setState({ otpInvalid: data == false, otpTestSuccess: data == true }))
            .catch((e) => {
                console.error(e);
            })
    }

    finalizeMFA() {
        this.setState({ loading: true }, () => {
            Api.get(AuthEndpoints.enableMFA)
                .then(({ data }) => { this.setState({ loading: false }); this.props.close(); this.props.refresh(); })
                .catch((e) => {
                    console.error(e);
                })
        })
    }

    render() {
        const { classes } = this.props;

        if (this.props.isOpen && !this.state.mfa_url && !this.state.loading) {
            this.generateMFAKey();
        }

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                scroll="body"
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                {
                    this.state.loading ?
                        <DialogContent style={{ padding: 0, width: '100%', minHeight: 300 }}>
                            <Loading />
                        </DialogContent>
                        :
                        <DialogContent style={{ padding: 0, width: '100%' }}>
                            <Tabs
                                value={this.state.tab}
                                onChange={(event, value) => this.setState({ tab: value })}
                                variant="fullWidth"
                                indicatorColor="primary"
                                textColor="primary"
                                style={{
                                    backgroundColor: '#EEEEEE',
                                    boxShadow: "0 10px 30px -6px rgba(0, 0, 0, 0.1), 0 4px 25px 0px rgba(0, 0, 0, 0.03), 0 8px 10px -2px rgba(0, 0, 0, 0.05)",
                                    borderTopLeftRadius: 4,
                                    borderTopRightRadius: 4
                                }}
                            >
                                <Tab style={{ flex: 1, flexGrow: 1, ...(this.state.tab === 0 ? { backgroundColor: '#ffffff' } : {}) }} label="Setup" />
                                <Tab style={{ flex: 1, flexGrow: 1, ...(this.state.tab === 1 ? { backgroundColor: '#ffffff' } : {}) }} label="Test" />
                                <Tab style={{ flex: 1, flexGrow: 1, ...(this.state.tab === 2 ? { backgroundColor: '#ffffff' } : {}) }} label="Done" />
                            </Tabs>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 20 }}>
                                {this.state.tab === 0 && (
                                    <div style={{ textAlign: 'center' }}>
                                        <h3>Scan QR Code:&nbsp;&nbsp;&nbsp;<span style={{ color: '#888888', fontSize: '0.9em' }}><FontAwesomeIcon icon={faApple} />/<FontAwesomeIcon icon={faAndroid} /></span></h3>

                                        <div style={{ padding: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <QRCode
                                                size={256}
                                                renderAs="svg"
                                                value={this.state.mfa_url}
                                            />
                                        </div>

                                        <TextDivider style={{ fontSize: '1.4em', color: '#888888' }} >OR</TextDivider>

                                        <h3>Open/Copy the link:&nbsp;&nbsp;&nbsp;<span style={{ color: '#888888', fontSize: '0.9em' }}><FontAwesomeIcon icon={faChrome} />/<FontAwesomeIcon icon={faFirefox} />/<FontAwesomeIcon icon={faSafari} />/<FontAwesomeIcon icon={faWindows} /></span></h3>

                                        <div style={{ backgroundColor: '#EEEEEE', borderRadius: 8, padding: 20, overflowX: 'hidden' }}>
                                            <a href={this.state.mfa_url} style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {this.state.mfa_url}
                                            </a>
                                            <br />
                                            <br />

                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                                <textarea
                                                    ref={(copyTextarea) => this.copyTextarea = copyTextarea}
                                                    value={this.state.mfa_url}
                                                    rows="1"
                                                    readOnly
                                                    onClick={() => this.copyUrl()}
                                                    style={{ display: 'inline-block', flex: 1, border: 'none', backgroundColor: 'transparent', width: '100%', height: 30, resize: 'none', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
                                                />
                                                <IconButton onClick={() => this.copyUrl()}>
                                                    <FileCopy />
                                                </IconButton>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.state.tab === 1 && (
                                    <div style={{ textAlign: 'center' }}>
                                        <CustomInput
                                            labelText={(this.state.otpInvalid ? "Invalid Pin" : this.state.otpTestSuccess ? "Pin Verified" : "Enter Pin")}
                                            id="otp"
                                            success={this.state.otpTestSuccess}
                                            error={this.state.otpInvalid}
                                            labelProps={{
                                                style: {
                                                    fontSize: 24,
                                                    textAlign: 'center'
                                                }
                                            }}
                                            inputProps={{
                                                onChange: (event) => {
                                                    if (/^[0-9]{0,6}$/.test(event.target.value))
                                                        this.setState({ otp: event.target.value, otpInvalid: false });
                                                },
                                                value: this.state.otp,
                                                onKeyPress: (e) => {
                                                    if (e.key === 'Enter') {
                                                        this.this.testMFA();
                                                    }
                                                },
                                                inputProps: {
                                                    style: {
                                                        fontSize: 24,
                                                        letterSpacing: 4,
                                                        textAlign: 'center'
                                                    }
                                                }
                                            }}
                                        />

                                        <Button
                                            onClick={() => this.testMFA()}
                                            color="rose"
                                            round
                                        >
                                            Check
                                    </Button>
                                    </div>
                                )}
                                {this.state.tab === 2 && (
                                    <div style={{ textAlign: 'center', paddingTop: 20 }}>
                                        <div style={{ width: '35%', height: 'auto', marginLeft: 'auto', marginRight: 'auto', marginBottom: 30 }}>
                                            <CheckAnimated />
                                        </div>

                                        <h1 style={{ color: 'var(--green)' }}>You're ready to go</h1>

                                        <h3 style={{ color: 'var(--green)' }}>Just click below and get started</h3>

                                    </div>
                                )}
                            </div>


                            {/*  style={{ overflow: 'visible' }} */}
                            {/* <QRCode
                        renderAs="svg"
                        value={this.state.mfa_url}
                    /> */}
                        </DialogContent>
                }
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>
                    {
                        this.state.tab === 2 ?
                            <Button
                                onClick={() => this.finalizeMFA()}
                                color="success"
                                round
                            >
                                Start Using 2FA
                                &nbsp;&nbsp;
                                        <FontAwesomeIcon icon={faCheck} />
                            </Button>
                            :
                            <Button
                                onClick={() => this.setState({ tab: (this.state.tab + 1) })}
                                color="primary"
                                round
                            >
                                Next
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faChevronRight} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(MFADialog);